var _path, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoEmployees(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 360,
    viewBox: "0 0 480 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Name=Sin Empleados, Shape=-"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 85"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.892 357.194C191.381 353.829 150.545 342.404 121.168 312.853C91.8576 283.37 81.3823 242.436 77.6248 201.012C73.3721 154.129 69.8655 103.901 98.8516 66.8308C130.607 26.2195 181.565 6.88548 232.892 2.44206C289.547 -2.46253 358.573 -4.39963 392.31 41.4261C425.196 86.0958 384.393 145.777 379.08 201.012C374.688 246.674 395.639 299.09 364.306 332.565C332.629 366.408 279.07 360.938 232.892 357.194Z",
    fill: "url(#paint0_linear_2255_99296)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector_2",
    filter: "url(#filter0_dd_2255_99296)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.637 29C347.225 29 412 127.809 412 230.387C412 307.073 321.836 331 246.637 331C166.942 331 68 311.658 68 230.387C68 124.337 142.645 29 246.637 29Z",
    fill: "url(#paint1_linear_2255_99296)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "remix-icons/outlined/user/team-line",
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M240.35 173.333C249.008 173.333 257.312 176.845 263.434 183.097C269.556 189.348 272.996 197.826 272.996 206.667V246.667H259.937V206.667C259.938 201.565 258.029 196.657 254.601 192.945C251.174 189.233 246.487 186.999 241.499 186.7L240.35 186.667C235.354 186.667 230.546 188.616 226.911 192.115C223.276 195.615 221.088 200.401 220.795 205.493L220.762 206.667V246.667H207.704V206.667C207.704 197.826 211.144 189.348 217.266 183.097C223.388 176.845 231.692 173.333 240.35 173.333ZM197.911 193.333C199.732 193.333 201.502 193.553 203.199 193.96C202.083 197.354 201.422 200.886 201.234 204.46L201.175 206.667V207.24C200.425 206.966 199.644 206.787 198.851 206.707L197.911 206.667C195.476 206.667 193.129 207.593 191.326 209.264C189.524 210.936 188.396 213.232 188.163 215.707L188.117 216.667V246.667H175.059V216.667C175.059 210.478 177.466 204.544 181.752 200.168C186.037 195.792 191.85 193.334 197.911 193.333ZM282.789 193.333C288.85 193.334 294.662 195.792 298.948 200.168C303.234 204.544 305.641 210.478 305.641 216.667V246.667H292.583V216.667C292.583 214.181 291.676 211.784 290.039 209.944C288.402 208.104 286.153 206.952 283.729 206.714L282.789 206.667C281.647 206.667 280.55 206.867 279.525 207.233V206.667C279.525 202.227 278.819 197.96 277.507 193.973C279.198 193.553 280.968 193.333 282.789 193.333ZM197.911 153.333C202.24 153.333 206.391 155.089 209.453 158.215C212.514 161.341 214.233 165.58 214.233 170C214.233 174.42 212.514 178.66 209.453 181.785C206.391 184.911 202.24 186.667 197.911 186.667C193.581 186.667 189.43 184.911 186.369 181.785C183.307 178.66 181.588 174.42 181.588 170C181.588 165.58 183.307 161.341 186.369 158.215C189.43 155.089 193.581 153.333 197.911 153.333ZM282.789 153.333C287.118 153.333 291.27 155.089 294.331 158.215C297.392 161.341 299.112 165.58 299.112 170C299.112 174.42 297.392 178.66 294.331 181.785C291.27 184.911 287.118 186.667 282.789 186.667C278.46 186.667 274.308 184.911 271.247 181.785C268.186 178.66 266.466 174.42 266.466 170C266.466 165.58 268.186 161.341 271.247 158.215C274.308 155.089 278.46 153.333 282.789 153.333ZM197.911 166.667C197.045 166.667 196.214 167.018 195.602 167.643C194.99 168.268 194.646 169.116 194.646 170C194.646 170.884 194.99 171.732 195.602 172.357C196.214 172.982 197.045 173.333 197.911 173.333C198.776 173.333 199.607 172.982 200.219 172.357C200.831 171.732 201.175 170.884 201.175 170C201.175 169.116 200.831 168.268 200.219 167.643C199.607 167.018 198.776 166.667 197.911 166.667ZM282.789 166.667C281.923 166.667 281.093 167.018 280.481 167.643C279.869 168.268 279.525 169.116 279.525 170C279.525 170.884 279.869 171.732 280.481 172.357C281.093 172.982 281.923 173.333 282.789 173.333C283.655 173.333 284.485 172.982 285.098 172.357C285.71 171.732 286.054 170.884 286.054 170C286.054 169.116 285.71 168.268 285.098 167.643C284.485 167.018 283.655 166.667 282.789 166.667ZM240.35 113.333C247.276 113.333 253.919 116.143 258.817 121.144C263.715 126.145 266.466 132.928 266.466 140C266.466 147.073 263.715 153.855 258.817 158.856C253.919 163.857 247.276 166.667 240.35 166.667C233.423 166.667 226.781 163.857 221.883 158.856C216.985 153.855 214.233 147.073 214.233 140C214.233 132.928 216.985 126.145 221.883 121.144C226.781 116.143 233.423 113.333 240.35 113.333ZM240.35 126.667C236.887 126.667 233.565 128.072 231.116 130.572C228.667 133.073 227.292 136.464 227.292 140C227.292 143.536 228.667 146.928 231.116 149.428C233.565 151.929 236.887 153.333 240.35 153.333C243.813 153.333 247.135 151.929 249.583 149.428C252.032 146.928 253.408 143.536 253.408 140C253.408 136.464 252.032 133.073 249.583 130.572C247.135 128.072 243.813 126.667 240.35 126.667Z",
    fill: "#41435B"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2255_99296",
    x: 60,
    y: 25,
    width: 360,
    height: 318,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.254902 0 0 0 0 0.262745 0 0 0 0 0.356863 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2255_99296"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.254902 0 0 0 0 0.262745 0 0 0 0 0.356863 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2255_99296",
    result: "effect2_dropShadow_2255_99296"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2255_99296",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2255_99296",
    x1: 405,
    y1: 180,
    x2: 74.7932,
    y2: 180,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13729,
    stopColor: "#5A46FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866499,
    stopColor: "#1E95FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2255_99296",
    x1: 68,
    y1: 180,
    x2: 412,
    y2: 180,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F95C5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB432"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoEmployees);
export default __webpack_public_path__ + "static/media/noEmployees.fb0d75fe1492b4316c4fe98ad2f19564.svg";
export { ForwardRef as ReactComponent };